module.exports = __webpack_public_path__ + "img/student.7e139b6f.png";